module.exports = __webpack_public_path__ + "img/flag.864fe308.svg";